import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-creative';
import { Navigation, Autoplay } from 'swiper/modules';

export default {
  init() {
    console.log('favola');
    gsap.registerPlugin(ScrollTrigger);  
    const metodo = document.querySelector('#favolaMetodo');
    const arrayMetodo = gsap.utils.toArray('.singleMetodo');
    
    const storia = document.querySelector('#favolaStoria');
    const arrayStoria = gsap.utils.toArray('.singleStoria');

    arrayMetodo.forEach((metodo, index) => {
      gsap.to(metodo, {
        scrollTrigger:{
          trigger: metodo,
          start: '-=50% center',
          end: 'top 40%',
          scrub: 1,
          markers: false,
          toggleActions: 'play none none reverse',
        },
        opacity:1,
      });
    });


    
    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: storia,
        start: '20% center',
        end: 'bottom 40%',
        scrub: 1,
        markers: false,
        pin: true,
        anticipatePin: 1,
      }
    });

    arrayStoria.forEach((storia, index) => {
      tl2.to(storia, {
        y: `${-97 * index}%` , 
        ease: 'power1. inOut',
      });
    });
    

    new Swiper('.swiperFavolaLoghi', {
      modules: [Autoplay],
			slideToClickedSlide: false,
			slidesPerView: 'auto',
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      speed: 3000,
			breakpoints: {
				1024: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 3,
				},
				320: {
					slidesPerView: 2,
				},
			},
			spaceBetween: 20,
			direction: 'horizontal',
      autoplay: {
        delay: 0,
      },

    });

    new Swiper('.swiperFavolaProdotti', {
			modules: [Navigation],
			slideToClickedSlide: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			slidesPerView: 3,
			breakpoints: {
				1024: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 2,
				},
				320: {
					slidesPerView: 1,
				},
			},
			spaceBetween: 50,
			direction: 'horizontal',
			loop: false,
    });


    document.querySelectorAll('.clamp-toggle').forEach((el) => {
      el.addEventListener('click', () => {
        el.classList.toggle('clamp-open');
        console.log('Toggled clamp-open');
      });
    });    

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};